
import {Injectable} from '@angular/core';
import {SwitchBoard} from './SwitchBoard';

@Injectable({
  providedIn: 'root'
})
export class LoadingService{
    constructor(private switchBoard: SwitchBoard){}

    triggerLoadingEvent(text: any) {
      this.switchBoard.onLoadingWheel.next(text);
    }

}
